import { z } from 'zod';
import { authoritativeTeamStateSchema } from './domain/game.js';
export const resourceAssignmentCommandSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('GENERATE'),
        expectedGameVersion: z.number().int().nonnegative(),
        expectedTeamVersion: z.number().int().nonnegative(),
        rulesetId: z.string(),
        randomSeed: z.string(),
    }),
    z.object({
        action: z.literal('ADJUST'),
        expectedGameVersion: z.number().int().nonnegative(),
        expectedTeamVersion: z.number().int().nonnegative(),
        adjustmentReason: z.string().min(1).max(1000),
        assignment: authoritativeTeamStateSchema,
    }),
    z.object({
        action: z.literal('REVEAL'),
        expectedGameVersion: z.number().int().nonnegative(),
        expectedTeamVersion: z.number().int().nonnegative(),
    }),
]);
export const resourceAssignmentViewSchema = z.object({
    teamId: z.string(),
    version: z.number().int().positive(),
    status: z.enum(['PREPARED', 'REVEALED']),
    revealedAt: z.string().datetime().optional(),
    assignment: authoritativeTeamStateSchema,
    rulesetId: z.string().optional(),
    randomSeed: z.string().optional(),
    moderatorAdjustmentReason: z.string().optional(),
});
export const revealAllHandsCommandSchema = z
    .object({
    expectedGameVersion: z.number().int().nonnegative(),
})
    .strict();
//# sourceMappingURL=resources.js.map